__turbopack_context__.v({
  "box": "brand-slider-module__N6VlZG__box",
  "brandArea": "brand-slider-module__N6VlZG__brandArea",
  "group": "brand-slider-module__N6VlZG__group",
  "link": "brand-slider-module__N6VlZG__link",
  "marquee": "brand-slider-module__N6VlZG__marquee",
  "scroll": "brand-slider-module__N6VlZG__scroll",
  "track": "brand-slider-module__N6VlZG__track",
});
